module.exports = __webpack_public_path__ + "static/media/resca.f6cbe82c.png";